import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="turbo-animation"
// Add this controller to a container to animate Turbo Stream replacements
export default class extends Controller {
  connect() {
    // Listen for turbo:before-stream-render events
    this.boundAnimateStreamRender = this.animateStreamRender.bind(this)
    document.addEventListener("turbo:before-stream-render", this.boundAnimateStreamRender)
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.boundAnimateStreamRender)
  }

  animateStreamRender(event) {
    const stream = event.target
    const action = stream.getAttribute("action")

    // Only animate replace actions for messages
    if (action === "replace") {
      const targetId = stream.getAttribute("target")
      const existingElement = document.getElementById(targetId)

      // Only animate message elements
      if (existingElement && existingElement.classList.contains("message")) {
        event.preventDefault()

        // Add fade-out to existing element
        existingElement.style.transition = "opacity 0.15s ease-out"
        existingElement.style.opacity = "0"

        setTimeout(() => {
          // Perform the default replacement
          stream.performAction()

          // Add fade-in animation to new element
          const newElement = document.getElementById(targetId)
          if (newElement) {
            newElement.classList.add("message-animate-in")
          }
        }, 150)
      }
    }
  }
}
